/*  ==========================================================================
    TEXT PIC BOX V2

    INFO:
    - needs "object-fit-images" (https://github.com/bfred-it/object-fit-images)
      to make object fit possible for images in older browsers (especially ie11)
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import objectFitImages from 'object-fit-images';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initTextPicBoxV2($element) {

    // magnific popup
    utils.mfp.initGallery($element);

    // object fit fix for older browsers (especially ie11)
    let images = $element.find('img');
    objectFitImages(images, {
        watchMQ: true
    });

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/text-pic-box-v2.js